function convertVariable(key, value, conversions) {
  if (value === null || value === undefined) {
    return
  }

  if (Array.isArray(value)) {
    return value.sort().forEach(oneOfValues => convertVariable(key, oneOfValues, conversions))
  }

  if (typeof value === 'object') {
    const nextLevelKeys = Object.keys(value).sort()

    return nextLevelKeys.forEach(nextLevelKey => convertVariable(`${key}.${nextLevelKey}`, value[nextLevelKey], conversions))
  }

  conversions.push(`${key}=${value}`)
}

export default function convertVariablesToCacheableQueryString(variables) {
  const keys = Object.keys(variables).sort()
  const conversions = []

  keys.forEach(key => convertVariable(key, variables[key], conversions))

  return conversions.join('&')
}
